import { colors } from '../../partners/tokens'

export default {
  defaultProps: {
    size: 'lg',
  },
  baseStyle: {
    _light: {
      borderWidth: 1,
      borderColor: 'gray.600',
      backgroundColor: 'white',
      _checked: {
        backgroundColor: 'primary.800',
        borderColor: 'primary.500',
      },
      _stack: {
        space: 4,
        borderRadius: 'lg',
        p: '4',
        width: 'full',
      },
    },
    _focusVisible: {
      _web: {
        style: {
          outlineWidth: '2px',
          outlineColor: colors.primary[500],
          outlineStyle: 'solid',
        },
      },
    },
  },
  variants: {
    'no-side-padding': () => ({
      _stack: {
        px: '0',
      },
    }),
    'no-padding': () => ({
      _stack: {
        p: '0',
      },
    }),
  },
  sizes: {
    lg: { _icon: { size: 5 }, _text: { fontSize: 'lg' } },
    md: { _icon: { size: 4 }, _text: { fontSize: 'md' } },
    sm: { _icon: { size: 3 }, _text: { fontSize: 'sm' } },
  },
}
